$fieldMaxWidth: 500px;

#license-pre-paid-form-field {
  width: 100%;
  max-width: $fieldMaxWidth;
  display: inline-block;
}

.title {
  margin-top: calc(var(--spacer) * 1.5);
  text-transform: uppercase;
  color: var(--chart-300-icon-buttons);
}

#check-license-validity-button {
  margin-left: calc(var(--spacer) / 2);
}

#product-name {
  max-width: $fieldMaxWidth;
}

#validity {
  max-width: $fieldMaxWidth;
}

#available-seats {
  max-width: $fieldMaxWidth;
}

#available-seats-for-servers {
  max-width: $fieldMaxWidth;
}

#available-seats-for-exchange-mailboxes {
  max-width: $fieldMaxWidth;
}

.tooltip-form-field-section {
  display: flex;
  flex-direction: row;
  justify-items: start;

  gz-tooltip {
    margin-left: var(--spacer);
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;

    .icon {
      font-size: 24px;
      line-height: 0.8;
      color: var(--chart-300-icon-buttons);
    }
  }
}

.text-form-field-section {
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-items: start;
}

.toggle-field {
  --label-width: 450px;
  --form-field-max-width: 400px;
}

.toggle-field-indented {
  --label-width: 385px;
  --form-field-max-width: 400px;
}

.pre-paid-license-details-container {
  gz-title[id='product-details-title'] {
    margin-bottom: calc(var(--spacer) + 2px);
  }

  gz-form-field[class='label-mw-250'] {
    margin-bottom: calc(var(--spacer) + 6px);
  }
}

.form-subtitle-info {
  margin-top: calc(var(--spacer) * 2);
  font-size: var(--body-size);
  color: var(--body-text-arrows-400);
}

.license-details-info-box {
  margin-top: calc(var(--spacer) * 3);
  line-height: 21px;
  padding: 8px 0;
}

gz-mdr-contact-details-section {
  margin-top: calc(var(--spacer) * 4);
  margin-bottom: calc(4 * var(--spacer));
}

:host([hasStackedFormFields]) {
  #check-license-validity-button {
    margin-left: 0;
    margin-top: var(--spacer);
  }

  .form-wrapper {
    display: flex;
    flex-direction: column;
  }

  gz-mdr-contact-details-section {
    margin-bottom: 0;
  }
}
